/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { unitTasksService } from '../../../_services/unitTasks.service'
import { taskOperationsService } from '../../../_services/taskOperations.service'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'

import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

class Form extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      key: 'info',
      isModal: this.props.isModal,
      id: this.props.isModal ? this.props.id : this.props.match.params.id,
      taskType: this.props.isModal ? this.props.taskType : this.props.match.params.taskType,
      data: {
        unitId: '',
        taskId: '',
        description: '',
        items: [
          { categoryId: '', brandId: '', productId: '', quantity: 0 }
        ]
      }
    }


  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {

    const { id } = this.state;

    if (id) {

      this.setState({ loading: true });

      await unitTasksService.getByIdClum(id)
        .then((res) => {
          
          let data = res.data;

          data["lastDescription"] = data.description;
          data["description"] = '';
          
          if (data.items && data.items.length>0) {

            let outputs = []
            data.items.forEach(item => {
              if (item.taskOperationProductType === 1) {
                outputs.push(item)
              }
            });

            data["items"] = data.items.filter(el => parseInt(el.taskOperationProductType, 0) === 0);
            data["outputs"] = outputs;

          }
          
          console.log(data);
          this.setState({ data: data, loading: false })

        })
        .catch((error) => {

          // console.log(error);

          this.setState({ loading: false });

        });

    }


  };

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });
    // values["taskType"] = this.state.taskType;
    values["taskId"] = this.state.data.taskId;
    values["PreviousUnitTaskId"] = this.state.data.id;
    // values["items"] = this.state.data.items;

    let items = values.items;
    let outputs = values.outputs;

    items.forEach(item => {
      item["taskOperationProductType"] = 0;
      item["quantity"] = 0;
      item["subQuantity"] = 0;
    });

    values["items"] = items.concat(outputs);

    console.log((values));

    taskOperationsService.clumAddTaskOperation(JSON.stringify(values))
      .then((res) => {
        console.log(res);

        this.setState({ loading: false, key: "images" });
        toastr.success('ارجاع سفارش انجام شد');
        // history.push("/admin/tasks/prum")

        setSubmitting(false);

        this.props.onSubmit()

      })
      .catch((error) => {
        // console.log(error)
        setSubmitting(false);
      });

  }

  handleError(error) {
    this.setState({ loading: false });
    // toastr.warning('مشکلی پیش آمد', error);
  }

  // validateForm = (errors) => {
  //   if (Object.keys(errors).length > 0) {
  //     // // console.log(errors)
  //     let obj = errors
  //     let { createdDate, workStartDate, firstName, lastName, codeMeli, idnumber, birthDate, cellNumber, address, travelBrandId, gender, degree, childrenCount,
  //       driverDocuments,
  //       user
  //     } = obj;
  //     if (createdDate || workStartDate || firstName || lastName || codeMeli || idnumber || birthDate || cellNumber || address || travelBrandId || gender || degree || childrenCount) {
  //       this.setState({ key: "info" })
  //     } else if (driverDocuments) {
  //       this.setState({ key: "images" })
  //     }
  //   }
  // }

  render() {
    const { data } = this.state;
    // const itemsCount = data.items.length;

    // const item = Yup.object().shape({
    //   quantity: Yup.number().min(1, 'مقدار کالا').required('مقدار'),
    //   productId: Yup.string().trim().nullable().required('محصول')
    // });

    const ValidationSchema = Yup.object().shape({
      unitId: Yup.string().trim().nullable().required('واحد')
      // items: Yup.array().of(item).min(itemsCount, 'تمامی اطلاعات').required('تمامی اطلاعات محصول'),
    });
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          // console.log(values);
          
          this.handleSubmit(values, setSubmitting);
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm,
          } = props;
          return (
            <div>
              <div className="row" style={{ position: "relative" }}>
                <form onSubmit={handleSubmit}>

                  {/* <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات فرآیند تولید"> */}
                  <div className="row">
                    <div className="col-lg-10 col-lg-offset-1">
                      <Step1 {...props} taskType={this.state.taskType} />
                      <Step2 {...props} taskType={this.state.taskType} />
                      <Step3 {...props} taskType={this.state.taskType} />
                    </div>
                    <div className="col-lg-10 col-lg-offset-1">
                      <button type="submit" className={"btn btn-primary btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}>
                        {isSubmitting ?
                          <AiOutlineLoading className="mdi-spin" size="22px" />
                          :
                          'ارجاع سفارش'
                        }
                      </button>
                    </div>
                  </div>

                  {/* </Tab>
                    <Tab eventKey="materialsTab" title="مواد اولیه"> */}



                  {/* </Tab>

                  </Tabs> */}
                  {/* {JSON.stringify(values)} */}
                </form>
              </div>
              {this.state.loading ? <Loading /> : ''}
            </div>
          );
        }}
      </Formik>
    );
  }
}

export default Form;
